import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  GEOCODING_REVERSE_URI,
  MIN_SPEED_THING_FLEX,
  THING_FIND_URI,
  THING_FETCH_URI,
  THING_PATCH_URI,
  THING_CONTACTS_FETCH_URI,
  THING_CONTACTS_CREATE_URI,
  THING_CONTACTS_THING_LIST,
  THING_CONTACTS_SET_URI,
  THING_CONTACTS_UPDATE_URI,
  THING_CONTACTS_ERASE_URI,
  THING_ALIAS_FIND_URI,
  THING_ALIAS_FETCH_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'
import dayjs from 'dayjs'
export default {
  actions: {
    update: ({ path, value }) => {
      return {
        action: 'update',
        value: value,
        path: `info/${path}`
      }
    },
    remove: ({ path }) => {
      return {
        action: 'remove',
        path: `info/${path}`
      }
    }
  },
  getThingsList({ projection, page } = { projection: null, page: null }) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, [])
      })
      // thingsListRace is an async function that fetches the list of things
      const p2 = this.thingsListRace(projection, page)
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  thingsListRace(projection, page) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [connectionService.getAccountId()]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      kwArgs.types = ['mrn:thing:vehicle', 'mrn:thing:flex']
      kwArgs.query_spec = {
        _p: Boolean(projection)
          ? projection
          : 'id,info,type,things,config,reported_state.mileage,reported_state.usage,aliases_qty,is_alias',
        _page: page,
        _limit: 200
      }
      connection.session.call(THING_FIND_URI, args, kwArgs, options).then(
        response => {
          resolve(response)
        },
        wampError => {
          reject(wampError)
        }
      )
    })
  },
  getThing(thingId) {
    return new Promise(resolve => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, [])
      })
      // getThingRace is an async function that fetches the thing by id
      const p2 = this.getThingRace(thingId)
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },

  getThingRace(thingId) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [thingId]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      kwArgs.query_spec = {
        _p:
          'id,info,info.photo,type,things,created_timestamp,config,reported_state.mileage,reported_state.usage,aliases_qty,is_alias'
      }
      connection.session.call(THING_FETCH_URI, args, kwArgs, options).then(
        response => {
          resolve(response)
        },
        wampError => {
          reject(wampError)
        }
      )
    })
  },

  getThingSharedAccounts(sourceThingId) {
    return new Promise(resolve => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, [])
      })
      const p2 = this.thingSharedAccountsRace(sourceThingId)
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },

  thingSharedAccountsRace(sourceThingId) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [{ source_thing_id: sourceThingId }]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      kwArgs.query_spec = { _p: 'account_name' }
      connection.session.call(THING_ALIAS_FIND_URI, args, kwArgs, options).then(
        response => {
          resolve(response)
        },
        wampError => {
          reject(wampError)
        }
      )
    })
  },

  getThingSharingAccount(aliasId) {
    return new Promise(resolve => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, [])
      })
      const p2 = this.thingSharingAccount(aliasId)
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },

  thingSharingAccount(aliasId) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [aliasId]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      kwArgs.query_spec = { _p: 'source_account_name' }
      connection.session
        .call(THING_ALIAS_FETCH_URI, args, kwArgs, options)
        .then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
    })
  },

  getThingType(thing) {
    const input = thing
    const fields = input.type.split(':')
    const type = fields[2]
    return type
  },
  //Marca
  getThingMake(thing) {
    const make = thing.info.make
    return make
  },
  //Modelo
  getThingModel(thing) {
    const model = thing.info.model
    return model
  },
  //Año
  getThingYear(thing) {
    const year = thing.info.year
    return year
  },
  //Color
  getThingColor(thing) {
    const color = thing.info.color
    return color
  },
  //Chasis
  getThingChasisNumber(thing) {
    const chasisNumber = thing.info.chassis_number
    return chasisNumber
  },
  //Motor
  getThingEngineNumber(thing) {
    const engineNumber = thing.info.engine_number
    return engineNumber
  },
  getThingDomain(thing) {
    const type = this.getThingType(thing)
    let domain
    switch (type) {
      case 'vehicle':
        domain = thing.info.domain
        break
      case 'flex':
        domain = this.getGpsId(thing)
        break
      default:
        break
    }
    return domain
  },
  getGpsId(thing) {
    const hasGps = thing.hasOwnProperty('things')
    if (hasGps) {
      const index = thing.things[0].indexOf('-')
      const sliceGpsId = thing.things[0].slice(index + 1)
      return sliceGpsId
    } else {
      return ''
    }
  },
  getThingStatus(type, data) {
    let status = ''
    if (type == 'vehicle') {
      switch (data.contact_on) {
        case true:
          data.speed > MIN_SPEED_THING_VEHICLE ? (status = 'moving') : ''
          data.speed <= MIN_SPEED_THING_VEHICLE ? (status = 'on') : ''

          break
        case false:
          data.speed > 0 ? (status = 'tow') : ''
          data.speed == 0 ? (status = 'stop') : ''
          break
      }
    } else if (type == 'flex') {
      switch (true) {
        case data.speed > MIN_SPEED_THING_FLEX:
          //En movimiento
          status = 'moving'
          break
        case data.speed == MIN_SPEED_THING_FLEX:
          //Detenido
          status = 'stop'
          break
      }
    }

    return status
  },
  getThingSubType(thing) {
    let subType = ''
    let icon = ''

    switch (thing) {
      case 'truck':
        subType = i18n.t('general.labels.things.subType.truck')
        icon = 'truck'
        break
      case 'road_machinery':
        subType = i18n.t('general.labels.things.subType.vial')
        icon = 'road_machinery'
        break
      case 'car':
        subType = i18n.t('general.labels.things.subType.car')
        icon = 'car'
        break
      case 'motorcycle':
        subType = i18n.t('general.labels.things.subType.motorcycle')
        icon = 'motorcycle'
        break
      case 'crane':
        subType = i18n.t('general.labels.things.subType.crane')
        icon = 'crane'
        break
      case 'heavy duty':
        subType = i18n.t('general.labels.things.subType.heavyDuty')
        icon = 'heavy_duty'
        break
      case 'van':
        subType = i18n.t('general.labels.things.subType.van')
        icon = 'van'
        break
      case 'flex':
        subType = i18n.t('general.labels.things.subType.flex')
        icon = 'bag'
        break
      case 'trailer':
        subType = i18n.t('general.labels.things.subType.trailer')
        icon = 'trailer'
        break
      case 'passenger':
        subType = i18n.t('general.labels.things.subType.passenger')
        icon = 'passenger'
        break
      default:
        // TODO --> cambiar el icono default de la tabla por algo generico
        subType = i18n.t('general.labels.things.subType.truck')
        icon = 'bag'
        break
    }
    return { subType, icon }
  },
  getThingIcon(marker, showEntityType = false) {
    const status = marker.status
    const heading = marker.heading
    const type = marker.type
    const subType = marker.subType
    let iconName

    const folder = showEntityType ? `${type}/${subType}` : 'generic'
    switch (folder) {
      case 'generic':
        if (status == 'on' || status == 'stop')
          iconName = `marker-circle-${status}`
        else if (heading != '')
          // Los flex no envían rumbo por eso necesitamos saber si el heading viene vacío
          // para armar el nombre del ícono correctamente
          iconName = `marker-circle-${status}-${heading}`
        else iconName = `marker-circle-on`
        break

      default:
        if (status == 'on' || status == 'stop')
          iconName = `marker-${subType}-${status}`
        else if (heading != '')
          iconName = `marker-${subType}-${status}-${heading}`
        else iconName = `marker-${subType}-${status}`
        break
    }

    // var images = require.context('@/assets/headings', true, /\.svg$/)
    return images(`./${folder}/${iconName}.svg`)
  },
  getThingHeading(heading) {
    if (typeof heading != 'number') {
      return ''
    }
    const cardinals = ['N', 'NW', 'W', 'SW', 'S', 'SE', 'E', 'NE']
    const position =
      Math.round((heading %= 360) < 0 ? heading + 360 : heading / 45) % 8
    const thingCardinal = cardinals[position]
    return i18n.t(`general.labels.heading.short.${thingCardinal}`)
  },
  //GetThingLocation -> esper un Array de THINGS, luego forma los objetos necesarios para hacer el CALL correspondiente para la GeoReferencia
  getThingLocation(things) {
    const connection = store.getters['authState/connection']
    const args = []
    const kwArgs = connectionService.createkwArgs()
    const options = {}

    things.map(thing => {
      const index = things.indexOf(thing)
      const latitude = thing.position.lat
      const longitude = thing.position.lng

      const geoLocationThing = { index, latitude, longitude }
      args.push(geoLocationThing)
    })
    const response = connection.session
      .call(GEOCODING_REVERSE_URI, args, kwArgs, options)
      .then(
        res => {
          return res
        },
        wampError => {
          console.log(wampError)
        }
      )
      .catch(err => {
        console.log('err')
        console.log(err)
      })

    return response
  },
  getThingLabel(label) {
    if (label.length > 12) {
      const formatedLabel = label.slice(0, 10) + '...'
      return formatedLabel
    } else {
      return label
    }
  },
  getThingId(thing) {
    const input = thing
    const fields = input.id.split(':')
    const thingId = fields[3]
    return thingId
  },
  getAccountId(thing) {
    const input = thing
    const fields = input.account_id.split(':')
    const accountId = fields[2]
    return accountId
  },

  getThingAgents(thing) {
    return []
  },
  getThingServiceSolution(thing) {
    if (thing.config.hasOwnProperty('service_plan')) {
      const solution = thing.config['service_plan'].name
      return solution
    } else return '-'
  },
  getThingServiceState(thing) {
    let strToReturn
    if (thing.config.hasOwnProperty('service_plan')) {
      const state = thing.config['service_plan'].status
      switch (state) {
        case 'active':
          strToReturn = i18n.t(
            'fleet_management.entities.entities_table.labels.data_table_status_active'
          )
          break
        case 'suspended':
          strToReturn = i18n.t(
            'fleet_management.entities.entities_table.labels.data_table_status_suspended'
          )
          break
        case 'inactive':
          strToReturn = i18n.t(
            'portal.general.account_settings.company_config.service_status.out'
          )
          break
        default:
          break
      }
    } else strToReturn = '-'
    return strToReturn
  },
  getThingCreated(thing) {
    const created = dayjs(thing.created_timestamp).format('DD/MM/YYYY')
    return created
  },

  prepareToUpdateThing(originDataThing, newDataThing) {
    const operations = []
    // Evaluamos si se cambió el value de algun campo que no sea el de user_info
    if (originDataThing.label != newDataThing.label) {
      operations.push(
        this.actions['update']({ path: 'label/', value: newDataThing.label })
      )
    }
    if (originDataThing.mileageReading != newDataThing.mileageReading) {
      operations.push(
        this.actions['update']({
          path: 'mileage_reading/',
          value: newDataThing.mileageReading
        })
      )
    }
    if (originDataThing.usageReading != newDataThing.usageReading) {
      operations.push(
        this.actions['update']({
          path: 'usage_reading/',
          value: newDataThing.usageReading
        })
      )
    }

    // Evaluamos si la foto cambió
    if(originDataThing.photo != newDataThing.photo) {
      operations.push(
        this.actions['update']({
          path: 'photo/',
          value: newDataThing.photo
        })
      )
    }

    // Evaluamos si se eliminó una keys de user_info
    const originalUserInfoKeys = Object.keys(originDataThing.userInfo)
    const currentUserInfoKeys = Object.keys(newDataThing.userInfo)

    const dataThingKeysExclude = originalUserInfoKeys.filter(
      key => !currentUserInfoKeys.includes(key)
    )
    dataThingKeysExclude.forEach(key => {
      operations.push(this.actions['remove']({ path: `user_info/${key}` }))
    })

    if (
      JSON.stringify(originDataThing.userInfo) !=
      JSON.stringify(newDataThing.userInfo)
    ) {
      // Evaluamos si se agregaron nuevas keys en user_info
      const newUserInfoKeys = currentUserInfoKeys.filter(
        key => !originalUserInfoKeys.includes(key)
      )
      newUserInfoKeys.forEach(key => {
        operations.push(
          this.actions['update']({
            path: `user_info/${key}`,
            value: newDataThing.userInfo[key]
          })
        )
      })

      // Evaluamos si los values cambiaron en user_info
      const userInfoKeys = currentUserInfoKeys.filter(key =>
        originalUserInfoKeys.includes(key)
      )
      userInfoKeys.forEach(key => {
        if (originDataThing.userInfo[key] != newDataThing.userInfo[key]) {
          operations.push(
            this.actions['update']({
              path: `user_info/${key}`,
              value: newDataThing.userInfo[key]
            })
          )
        }
      })
    }

    return operations
  },

  updateThing(uriId, actionsForThingsPatch) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']

      const args = [uriId, actionsForThingsPatch]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      // thingsListRace is a async function that fetch the person list
      const p2 = new Promise((resolve, reject) => {
        connection.session.call(THING_PATCH_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getThingMileageReading(thing) {
    if (thing.reported_state.hasOwnProperty('mileage')) {
      const mileage = Math.round(thing.reported_state.mileage * 1000)
      return mileage
    } else if (thing.info.hasOwnProperty('mileage_reading')) {
      const mileage = thing.info.mileage_reading
      return mileage
    } else {
      return 0
    }
  },
  getThingUsageReading(thing) {
    let usage = 0
    if (thing.reported_state.hasOwnProperty('usage')) {
      usage = Math.round(thing.reported_state.usage / 3600)
    } else if (thing.info.hasOwnProperty('usage_reading')) {
      usage = thing.info.usage_reading
    }
    return usage
  },
  getThingServiceList(thing) {
    if (thing.config.hasOwnProperty('services')) {
      const services = thing.config.services
      const serviceList = []
      for (const service in services) {
        if (services[service].status !== 'inactive') {
          serviceList.push(Object.assign({ name: service }, services[service]))
        }
      }
      return serviceList
    } else return '-'
  },
  getThingServiceName(service) {
    let name
    switch (service) {
      case 'mrn:service:live_tracking':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_live_tracking'
        )
        break
      case 'mrn:service:recovery':
      case 'mrn:service:gps_recovery':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_gps_recovery_or_recovery'
        )
        break
      case 'mrn:service:mrn:service:customer_tracking':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_customer_tracking'
        )
        break
      case 'mrn:service:gps_roaming':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_gps_roaming'
        )
        break
      case 'mrn:service:vlu_recovery':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_vlu_recovery'
        )
        break
      case 'mrn:service:dual_sim_br':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dual_sim_br'
        )
        break
      case 'mrn:service:dual_sim_cl':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dual_sim_cl'
        )
        break
      case 'mrn:service:dual_sim_uy':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dual_sim_uy'
        )
        break
      case 'mrn:service:speed_limit_by_road_type':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_speed_limit_by_road_type'
        )
        break
      case 'mrn:service:panic_button':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_panic_button'
        )
        break
      case 'mrn:service:driver_door':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_driver_door'
        )
        break
      case 'mrn:service:cargo_gate':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_cargo_gate'
        )
        break
      case 'mrn:service:semi_detach':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_semi_detach'
        )
        break
      case 'mrn:service:tamper_sensor':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_tamper_sensor'
        )
        break
      case 'mrn:service:fuel_cut_off':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_fuel_cut_off'
        )
        break
      case 'mrn:service:bypass_key':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_bypass_key'
        )
        break
      case 'mrn:service:timed_bypass_key':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_timed_bypass_key'
        )
        break
      case 'mrn:service:garbi_config':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_garbi_config'
        )
        break
      case 'mrn:service:arflota':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_arflota'
        )
        break
      case 'mrn:service:persat':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_persat'
        )
        break
      case 'mrn:service:panic_button_monitoring':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_panic_button_monitoring'
        )
        break
      case 'mrn:service:driver_door_monitoring':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_driver_door_monitoring'
        )
        break
      case 'mrn:service:cargo_gate_monitoring':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_cargo_gate_monitoring'
        )
        break
      case 'mrn:service:semi_detach_monitoring':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_semi_detach_monitoring'
        )
        break
      case 'mrn:service:tamper_sensor_monitoring':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_tamper_sensor_monitoring'
        )
        break
      case 'mrn:service:lasso_disconnected_monitoring':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_lasso_disconnected_monitoring'
        )
        break
      case 'mrn:service:telemetry':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_telemetry'
        )
        break
      case 'mrn:service:safe_driving':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_safe_driving'
        )
        break
      case 'mrn:service:car_transporter_lasso':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_car_transporter_lasso'
        )
        break
      case 'mrn:service:anti_jamming':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_anti_jamming'
        )
        break
      case 'mrn:service:dump_truck_sensor':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dump_truck_sensor'
        )
        break
      case 'mrn:service:dump_truck_tilt':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dump_truck_tilt'
        )
        break
      case 'mrn:service:temperature_sensor':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_temperature_sensor'
        )
        break
      case 'mrn:service:accelerometer':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_accelerometer'
        )
        break
      case 'mrn:service:ibutton':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_ibutton'
        )
        break
      case 'mrn:service:generic_seat_passenger':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_seat_passenger'
        )
        break
      case 'mrn:service:seat_passenger':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_seat_passenger'
        )
        break
      case 'mrn:service:generic_unauthorized_stop':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_unauthorized_stop'
        )
        break
      case 'mrn:service:generic_put_into_service':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_put_into_service'
        )
        break
      case 'mrn:service:generic_taken_out_of_service':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_taken_out_of_service'
        )
        break
      case 'mrn:service:generic_still_detached':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_still_detached'
        )
        break
      case 'mrn:service:generic_event_test':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_event_test'
        )
        break
      case 'mrn:service:generic_delivery':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_delivery'
        )
        break
      case 'mrn:service:generic_sharped_turn':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_sharped_turn'
        )
        break
      case 'mrn:service:generic_hard_brake':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_generic_hard_brake'
        )
        break
      case 'mrn:service:generic_hard_acceleration':
          name = i18n.t(
            'fleet_management.entities.entity_info.labels.card_field_service_generic_hard_acceleration'
          )
          break
      case 'mrn:service:temperature_multi_sensor':
          name = i18n.t(
            'fleet_management.entities.entity_info.labels.card_field_service_temperature_multi_sensor'
          )
          break
      default:
        name = '-'
        break
    }
    return name
  },
  getThingContacts(thingId) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [thingId]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(THING_CONTACTS_FETCH_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateThingContacts(id, contactsList) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [id, { emergency_contacts: contactsList }]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(THING_CONTACTS_UPDATE_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  eraseThingContacts(id) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [id]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(THING_CONTACTS_ERASE_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createThingContacts(id, contactsList) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [
        {
          account_id: connectionService.getAccountId(),
          thing_id: id,
          emergency_contacts: contactsList
        }
      ]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(THING_CONTACTS_CREATE_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  splitArray(array, elementosPorSubArray) {
    const result = []

    for (let i = 0; i < array.length; i += elementosPorSubArray) {
      const subArray = array.slice(i, i + elementosPorSubArray)
      result.push(subArray)
    }

    return result
  },
  createAndUpdateThingsFromEmergencyContact(
    idContact,
    firstName,
    lastName,
    thingsList
  ) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [
        {
          account_id: connectionService.getAccountId(),
          contact_id: idContact,
          first_name: firstName,
          last_name: lastName,
          things: [
            {
              action: 'update',
              value: thingsList
            }
          ]
        }
      ]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(THING_CONTACTS_SET_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  eraseThingsFromEmergencyContact(idContact, firstName, lastName, thingsList) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [
        {
          account_id: connectionService.getAccountId(),
          contact_id: idContact,
          first_name: firstName,
          last_name: lastName,
          things: [
            {
              action: 'remove',
              value: thingsList
            }
          ]
        }
      ]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(THING_CONTACTS_SET_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getThingContactsThingList(account_id, contact_id) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [account_id, contact_id]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(THING_CONTACTS_THING_LIST, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  sortEntities(entities) {
    return entities.sort((a, b) => {
      const x = a.name.toUpperCase(),
        y = b.name.toUpperCase()
      return x == y ? 0 : x > y ? 1 : -1
    })
  },
  //ERRORS
  getErrorMessageByCode(code) {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.internal_error':
        strToReturn = i18n.t(
          'general.snackbarComponent.errors.default_error_msje'
        )
        break

      case 'wamp.error.timeout':
        strToReturn = i18n.t('general.snackbarComponent.errors.timeout')
        break
      default:
        strToReturn = i18n.t(
          'general.snackbarComponent.errors.default_error_msje'
        )
        break
    }
    return strToReturn
  }
}
